const comments = [
  {
    avatar: 'bg-primary-100 text-primary-700',
    initial: '瓜',
    name: '吃瓜不嫌事大',
    time: '3小时前',
    content: '这个瓜我吃了三天了还没吃完，每天都有新进展，太精彩了！每日黑料网的更新速度是真的快，比微博热搜还及时。',
    likes: '2.3k',
  },
  {
    avatar: 'bg-accent-100 text-accent-700',
    initial: '理',
    name: '理性吃瓜群众',
    time: '5小时前',
    content: '作为老吃瓜人，这个平台的信息聚合确实做得不错，同一个事件能看到不同来源的说法，方便自己判断真假。希望继续保持！',
    likes: '1.8k',
  },
  {
    avatar: 'bg-secondary-100 text-secondary-700',
    initial: '匿',
    name: '匿名小号123',
    time: '8小时前',
    content: '之前在别的平台追瓜总是漏掉重要进展，自从用了每日黑料网，再也不用担心错过任何爆料了。简直就是吃瓜党的福音！',
    likes: '956',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          网友热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          听听吃瓜群众们怎么说
        </p>

        <div className="space-y-4">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 ${c.avatar}`}>
                  {c.initial}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <div>
                      <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                      <span className="text-xs text-foreground-400 ml-2">{c.time}</span>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{c.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}